import { schema } from 'normalizr'
import store from '@/store'

export default new schema.Entity(
    'players',
    {},
    {
        idAttribute: value => (value.id ? value.id : value.trackNumber),
        processStrategy: player => ({
            // Meta.
            _type: 'player',
            // Fields.
            _device: () => store.getters.devices[player.deviceId],
            ...player,
        }),
    }
)
